import { render } from "./publicWelfareRecord.vue?vue&type=template&id=1e452494&scoped=true"
import script from "./publicWelfareRecord.vue?vue&type=script&lang=js"
export * from "./publicWelfareRecord.vue?vue&type=script&lang=js"

import "./publicWelfareRecord.vue?vue&type=style&index=0&id=1e452494&lang=scss&scoped=true"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e452494"]])

export default __exports__